<template>
  <v-row justify="center" align="stretch" dense>
    <v-col cols="12" lg="4">
      <Lottie
        :podcast2="true"
        data-aos="fade-up"
        data-aos-easing="ease"
        data-aos-duration="1000"
        data-aos-once="true"
      />
      <audio
        controls
        style="width: 100%; background-color: #f2f2f2; border-radius: 4px"
      >
        <source src="@/assets/modulo_01/podcasts/audio_2.mp3" type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>

      <v-btn
        block
        color="primary"
        depressed
        class="white--text"
        @click="showTranscription = !showTranscription"
      >
        <div>Visualizar transcrição</div>
      </v-btn>
    </v-col>

    <v-col cols="12" lg="8" v-if="showTranscription" class="pt-0 pb-0 pr-0 pl-1">
      <TextBlock style="height: 100%;">
        <Paragraph
          class="px-8 py-7 rounded-lg"
          style="overflow: auto; height: 100%; background: white; color: #333;"
        >
        Você já pensou sobre como usamos as <strong>vias públicas</strong>? Elas são compartilhadas por todos, e é importante que cada um de nós faça a sua parte para manter a ordem. Não é correto parar o carro em qualquer lugar ou agir sem considerar os outros. Existem algumas <strong>restrições</strong> de uso das vias, sabia? E essas restrições são importantes para organizar o bom uso e assegurar que todos possam utilizá-las de maneira <strong>segura</strong>.
        </Paragraph>
      </TextBlock>
    </v-col>
  </v-row>
</template>

<script>
import TextBlock from "@/components/TextBlock.vue";
import Paragraph from "@/components/Paragraph.vue";
import Lottie from "@/components/Lottie.vue";

export default {
  components: {
    TextBlock,
    Paragraph,
    Lottie,
  },
  data() {
    return {
      showTranscription: false,
    };
  },

  methods: {},
};
</script>

<style scoped></style>
